import { methodNotFoundError, invalidParamsError } from './JsonRpcError';
import { jsonRpcFailure } from './JsonRpcRequest';
import type { JsonRpcRequest, JsonRpcResult } from './JsonRpcRequest';
import type { CaptureViewTarget } from '../../ViewImageCapture/CaptureViewTarget';

// viewId / viewName のちょうど一方が string で指定されているときのみ target を返す。
// 両方指定・両方未指定・型不正は null（invalid params）。
// 通常は MCP サーバ側の引数検証で手前拒否されるため、ここはワイヤ契約所有者としての防御的検証
function parseTarget(params: Record<string, unknown>): CaptureViewTarget | null {
  const viewId = params['viewId'];
  const viewName = params['viewName'];
  if (viewId !== undefined && viewName === undefined) {
    return typeof viewId === 'string' ? { viewId } : null;
  }
  if (viewName !== undefined && viewId === undefined) {
    return typeof viewName === 'string' ? { viewName } : null;
  }
  return null;
}

// 接続中のビューモデルから指定したビューを画像として取得するリクエスト
export class GetViewImageRequest {
  static readonly METHOD = 'get_view_image';

  private constructor(
    private readonly _requestId: string,
    private readonly _target: CaptureViewTarget
  ) {}

  get requestId(): string {
    return this._requestId;
  }

  get target(): CaptureViewTarget {
    return this._target;
  }

  static from(req: JsonRpcRequest): JsonRpcResult<GetViewImageRequest> {
    if (req.method !== GetViewImageRequest.METHOD) {
      return jsonRpcFailure(req.id, methodNotFoundError('unknown_method', `unknown method: ${req.method}`));
    }

    const target = parseTarget(req.params);
    if (target === null) {
      return jsonRpcFailure(
        req.id,
        invalidParamsError('invalid_params_fields', `invalid params fields: ${JSON.stringify(req.params)}`)
      );
    }

    return { ok: true, value: new GetViewImageRequest(req.id, target) };
  }
}
